import { Constants } from '@/services'
import { IFornecedor, Generico } from '@/interfaces'
import { AttaHttpClientFactory } from './http/AttaHttpClientFactory'

const http = AttaHttpClientFactory.create(Constants.API.AttaServices.host)

export class FornecedorService {
	static async getValores() {
		const response = await http.get<Generico.IApiResponse<Array<IFornecedor.IFornecedorValores>>>('/fornecedor/valores')

		return response.data.result
	}
}
